module.exports = __webpack_public_path__ + "static/media/mail.3d479b79.svg";